module.exports = __webpack_public_path__ + "img/crown-loading-blue.77eeaf1a.svg";